import React from 'react'
import { Formik, Form } from 'formik';
import { MainInput, SubmitButton } from '../../components';
import { useNavigate } from 'react-router-dom';
import ROUTES from '../../../application/utils/Routes';
import services from '../../../ioc/services';
import { useDispatch, useSelector } from 'react-redux';
import { getFormSubmittingState } from '../../../application/store/selectors/ui';
import { setFormSubmitting } from '../../../application/store/actions/ui';
import { useEffect } from 'react';
import { getIsUserLoggedIn } from '../../../application/store/selectors/user';
import { useQuery } from '../../../application/hooks';
import { useState } from 'react';

function ResetPassword() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const query = useQuery();

    const isFormSubmiting = useSelector(getFormSubmittingState);
    const isUserLoggedIn = useSelector(getIsUserLoggedIn);

    const [token, setToken] = useState(null);

    useEffect(() => {
        if (isUserLoggedIn) navigate(ROUTES.DASHBOARD);

    }, [isUserLoggedIn, isFormSubmiting])

    useEffect(() => {
        if (query.get("token")) {
            setToken(query.get("token"))
        }
    }, [])

    return (
        <div className="w-full max-w-lg">
            <Formik
                initialValues={{}}
                enableReinitialize
                onSubmit={async (values) => {

                    if (!values.password) {
                        services.alert.toast.error("Please Enter Your Password")
                        return
                    }

                    if (!values.confirmPassword) {
                        services.alert.toast.error("Please Confirm Your Password")
                        return
                    }

                    if (values.password !== values.confirmPassword) {
                        services.alert.toast.error("Passwords Do Not Match")
                        return
                    }

                    if (!token) {
                        services.alert.toast.error("Invalid Token")
                        return
                    }

                    values.token = token;

                    dispatch(setFormSubmitting(true))

                    services.api.auth.passwordResetWithToken(values).then(res => {
                        services.alert.toast.success("Password Reset Successfully")
                        navigate(ROUTES.LOGIN)
                    })
                        .catch(err => {
                            services.alert.toast.error(err);
                        })
                        .finally(() => {
                            dispatch(setFormSubmitting(false))
                        })

                }}>
                <Form className="flex flex-col gap-7">
                    <MainInput label="Password" name="password" type="password" placeholder="" />
                    <MainInput label="Confirm Password" name="confirmPassword" type="password" placeholder="" />
                    <SubmitButton text="Reset Password" disabled={isFormSubmiting} />
                </Form>

            </Formik>



        </div>
    )
}

export default ResetPassword